/* eslint-disable import/no-anonymous-default-export */
export default {
  TOGGLE_NAVIGATION: 'TOGGLE_NAVIGATION',
};
